<neo-formulario-contacto-front [class]="'form-md'"></neo-formulario-contacto-front>